import config from 'crm/config'

const customerApi = `${config.apiHost}/oem-customer`

export default {
    getGroupList: {
        url: `${customerApi}/api/group_chat_category/chat`,
        type: 'GET',
    },
    getGroupGrouping: {
        url: `${customerApi}/api/group_chat_category`,
        type: 'GET',
    },
    deleteGrouping: {
        url: `${customerApi}/api/group_chat_category/{id}`,
        type: 'DELETE',
    },
    addGrouping: {
        url: `${customerApi}/api/group_chat_category`,
        type: 'POST',
    },
    editGrouping: {
        url: `${customerApi}/api/group_chat_category/{id}`,
        type: 'PUT',
    },
    moveGrouping: {
        url: `${customerApi}/api/group_chat_category/chat/move`,
        type: 'POST',
    },
    getMoveCount: {
        url: `${customerApi}/api/group_chat_category/chat/move/stat`,
        type: 'POST',
    },
}
